module.exports = __webpack_public_path__ + "static/media/green-calender-icon.cf5a9f18.svg";